import { Grid, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

const AvgStatsComponent = (props) => {
    const { min, max, mean, title, xs = 12, sm = 5 } = props
    const { t } = useTranslation();
    return (
        <Grid item xs={xs} sm={sm} container display="flex" alignItems="flex-start"
            sx={{ minHeight: 80 }}
        >
            <Grid item xs={12}>
                <Typography variant="h6" color="white" align="center">
                    {t(title)}
                </Typography>
            </Grid>
            {mean === null && min === null && max === null ? (
                <Grid item xs={12} mt={0.8}>
                    <Typography
                        align="center"
                        variant="h6"
                        sx={{ color: "white", opacity: 0.9 }}
                    >
                        {t("Data not available")}
                    </Typography>
                </Grid>
            ) :
                <Fragment>
                    {mean !== null && (
                        <Grid item xs={4}>
                            <Typography
                                align="center"
                                variant="h6"
                                sx={{ color: "white", opacity: 0.7 }}
                            >
                                {t("Average")}
                            </Typography>
                            <Typography align="center" variant="h5" color="white">
                                {mean}
                            </Typography>
                        </Grid>
                    )}

                    {min !== null && max !== null && (
                        <Fragment>
                            <Grid item xs={4}>
                                <Typography
                                    align="center"
                                    variant="h6"
                                    sx={{ color: "white", opacity: 0.7 }}
                                >
                                    Min
                                </Typography>
                                <Typography
                                    align="center"
                                    variant="h6"
                                    sx={{ color: "white", opacity: 0.9 }}
                                >
                                    {min}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography
                                    align="center"
                                    variant="h6"
                                    sx={{ color: "white", opacity: 0.7 }}
                                >
                                    Max
                                </Typography>
                                <Typography
                                    align="center"
                                    variant="h6"
                                    sx={{ color: "white", opacity: 0.9 }}
                                >
                                    {max}
                                </Typography>
                            </Grid>
                        </Fragment>
                    )}
                </Fragment>}
        </Grid>
    );
};

export default AvgStatsComponent;
